import { useMemo } from "react";
import { useAppSelector } from "../store-hooks";
import { selectActiveTool } from "./ui-selectors";
import { ToolName } from "./ui-slice";

/**
 * @returns True if the input tool is a report tool (PDF report, snapshot)
 * @param tool The tool name we want to check
 */
function isReportTool(
  tool: ToolName | null,
): tool is ToolName.createPDFReport | ToolName.createSnapshot {
  return tool === ToolName.createPDFReport || tool === ToolName.createSnapshot;
}

/**
 * @returns True if the current active tool is a report tool (PDF report, snapshot)
 */
export function useIsReportToolActive(): boolean {
  const activeTool = useAppSelector(selectActiveTool);
  return useMemo(() => isReportTool(activeTool), [activeTool]);
}

/**
 * @returns True if the current active tool is the snapshot tool
 */
export function useIsSnapshotToolActive(): boolean {
  const activeTool = useAppSelector(selectActiveTool);
  return useMemo(() => activeTool === ToolName.createSnapshot, [activeTool]);
}
